import { QBOBillSyncRequest } from '@kalos/kalos-rpc';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ReportClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export type QBOBillSyncVariables = {
  transactionIds: number[];
  dryRun: boolean;
  adminId: number;
};

// The Accounts Payable direct sync: posts AP transactions to QuickBooks as
// Bills and Vendor Credits, or previews it with dryRun. A real run marks the
// posted rows Processed, so it refreshes every transaction list; a preview
// changes nothing and leaves the cache alone.
export const useQBOBillSyncMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (variables: QBOBillSyncVariables) => {
      return await ReportClientService.SyncQBOBills(QBOBillSyncRequest.create(variables));
    },
    async onSuccess(_report, variables) {
      if (variables.dryRun) return;
      queryClient.removeQueries({ queryKey: [queryKeys.transactionGet.root] });
      await queryClient.invalidateQueries({ queryKey: [queryKeys.transaction.root] });
    },
  });
};
